import Vue from 'vue'

let refreshPromise = null
let socket = null
let onAuthFailure = null
let interceptorInstalled = false
let authFailureNotified = false
let socketRefreshAttempted = false

function clearLegacyUrlCredentials() {
  const hasLegacyCredentials = localStorage.getItem('key') !== null || localStorage.getItem('token') !== null

  localStorage.removeItem('key')
  localStorage.removeItem('token')

  if (hasLegacyCredentials) {
    localStorage.removeItem('lebot_usuario')
  }
}

function applyTokens(data, reconnectSocket) {
  authFailureNotified = false
  localStorage.setItem('access_token', data.access_token)
  localStorage.setItem('refresh_token', data.refresh_token)
  Vue.http.headers.common.Authorization = `Bearer ${data.access_token}`

  if (socket) {
    const wasConnected = socket.connected
    socket.auth = { token: data.access_token }

    if (reconnectSocket && wasConnected) {
      socket.disconnect()
    }

    if (!socket.connected) {
      socket.connect()
    }
  }
}

function clearSession() {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('key')
  localStorage.removeItem('token')
  localStorage.removeItem('lebot_usuario')
  delete Vue.http.headers.common.Authorization

  if (socket && socket.connected) {
    socket.disconnect()
  }
}

function notifyAuthFailure() {
  if (authFailureNotified) {
    return
  }

  authFailureNotified = true
  clearSession()

  if (typeof onAuthFailure === 'function') {
    onAuthFailure()
  }
}

function refreshJwt() {
  if (refreshPromise) {
    return refreshPromise
  }

  const refreshToken = localStorage.getItem('refresh_token')

  if (!refreshToken) {
    notifyAuthFailure()
    return Promise.reject(new Error('Sessão não renovável'))
  }

  refreshPromise = Vue.http.post('auth/refresh', {
    refresh_token: refreshToken
  }, {
    skipJwtRefresh: true
  }).then(response => {
    const data = response.data || {}

    if (!data.access_token || !data.refresh_token) {
      throw new Error('Resposta de renovação inválida')
    }

    applyTokens(data, true)
    return data
  }).catch(error => {
    notifyAuthFailure()
    throw error
  }).finally(() => {
    refreshPromise = null
  })

  return refreshPromise
}

function installHttpInterceptor() {
  if (interceptorInstalled) {
    return
  }

  interceptorInstalled = true

  Vue.http.interceptors.push((request, next) => {
    const accessToken = localStorage.getItem('access_token')

    if (accessToken) {
      request.headers.set('Authorization', `Bearer ${accessToken}`)
    }

    next(response => {
      if (response.status !== 401 || request.skipJwtRefresh) {
        return response
      }

      if (request.jwtRetried) {
        notifyAuthFailure()
        return response
      }

      request.jwtRetried = true

      return refreshJwt().then(data => {
        request.headers.set('Authorization', `Bearer ${data.access_token}`)
        return Vue.http(request)
      })
    })
  })
}

export default {
  configure(options = {}) {
    socket = options.socket || null
    onAuthFailure = options.onAuthFailure || null
    installHttpInterceptor()

    clearLegacyUrlCredentials()

    const accessToken = localStorage.getItem('access_token')

    if (accessToken) {
      Vue.http.headers.common.Authorization = `Bearer ${accessToken}`
    }

    if (socket) {
      socket.on('connect', () => {
        socketRefreshAttempted = false
      })

      socket.on('connect_error', error => {
        if (!error || error.message !== 'unauthorized') {
          return
        }

        if (socketRefreshAttempted) {
          notifyAuthFailure()
          return
        }

        socketRefreshAttempted = true
        refreshJwt().catch(() => {})
      })
    }
  },

  applyTokens,
  refreshJwt,
  clearSession
}
